import axios from 'axios'

const CarteService = {
    getMapMetrics: (params) => axios.get('/api/dashboard/carte/map-metrics', { params }),

    getMapMetricsByRegion: () => axios.get('/api/dashboard/carte/map-metrics-by-region')
}

export default CarteService
